module.exports = __webpack_public_path__ + "img/bk.355a1cc6.png";